<template>
  <div class="head-page">
    <Header
      :title="$t('recharge.title')"
      :iconkey="kefuicon"
      :iconurl="'-1'"
    />
    <div class="recharge-box">
      <div class="area">
        <van-cell @click="showPicker = true">
          <template #title>{{ $t("recharge.bType") }}</template>
          <template #default>{{ value }} </template>
          <template #right-icon
            ><van-icon name="arrow-down" size="20" style="margin-top: 5px"
          /></template>
        </van-cell>
      </div>
      <div class="area">
        <van-tabs v-model="active" type="card" @change="changeTab">
          <van-tab
            :title="getName(item.pay_type)"
            :name="item.pay_type"
            v-for="(item, index) in btypes"
            :key="index"
          />
        </van-tabs>
      </div>
      <div class="area txt-center">
        <ul>
          <li v-if="active != '3'">
            <QrCodeRecharge :account="address" :imgurl="icon" />
          </li>
          <li v-if="active == '3'">
            <BankRecharge />
          </li>
          <li>
            <van-uploader
              v-model="fileList"
              preview-size="160px"
              :max-count="1"
              :after-read="File1AferReade"
              :before-delete="file1Delete"
            />
            <p>{{ $t("recharge.token") }}</p>
          </li>
          <li>
            <van-field
              v-model="frm.num"
              type="number"
              :label="$t('recharge.num')"
              :placeholder="$t('recharge.numplaceholder')"
              class="tmp"
            />
          </li>
          <li>
            <div style="margin: 16px">
              <van-button @click="toSubmit()" class="web-btn" v-if="safeWapConfig.recharge_status == 1">
                <van-loading v-if="posting" /><span v-else>
                {{ $t("recharge.btn") }}</span></van-button>
            </div>
          </li>
        </ul>
      </div>
      <div class="area text-center" v-if="isshow">
        <CooperateBox @change-show="showCooperate" />
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom" round >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>

import Axios from "axios";
import Header from "@/components/Header";
import {   TokenLangKey,
  getTokenbyName,getToken } from "@/utils/cookies";
import { CooperateBox, QrCodeRecharge, BankRecharge } from "./components/index";
export default {
  name: "RechargeView",
  components: { Header, CooperateBox, QrCodeRecharge, BankRecharge },
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      isshow:false,
      kefuicon: require("../../assets/homeicon/kefu.png"),
      value: null,
      showPicker: false,
      columns: [],
      active: null,
      fileList: [],
      num: null,
      posting: false,
      idata: null,
      btypes: [],
      icon: null,
      address: null,
      frm: {
        c_id: null,
        num: null,
        payimg: null,
        a_id: null,
        type: 1,
      },
    };
  },
  methods: {
    showCooperate(val){
      this.isshow = val
    },
    async toSubmit(){
      if(!this.frm.num && this.frm.num <= 0){
        this.$toast.fail(this.$t('recharge.numplaceholder'))
        return
      }
      if(!(this.frm.payimg && this.frm.payimg.length > 0 )){
        this.$toast.fail(this.$t('recharge.tokenplaceholder'))
        return
      }

      if (this.posting) {
        return;
      }
      this.posting = true;
      await this.$http({
        method: "post",
        url: "recharge",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.frm.num = null
          this.frm.pay_img = null
          this.aferSub()
        })
        .catch(() => {
          this.posting = false;
        });
    },
    aferSub(){
      const tpy = this.safeWapConfig.recharge_subover_refre
      if(tpy == 1){
        //首页
        this.$router.push({ name: "home" });
      } else if(tpy == 2) {
        // 上一页 assets
        this.$router.back();
      }
    },
    getName(val) {
      if (val == 1) {
        return this.$t("common.paytype1");
      } else if (val == 2) {
        return this.$t("common.paytype2");
      } else if (val == 3) {
        return this.$t("common.paytype3");
      }
    },
    changeTab(val) {
      this.btypes.forEach((item) => {
        if (item.pay_type == val) {
          this.frm.a_id = item.id;
          this.icon = item.pay_img;
          this.address = item.address;
        }
      });
    },
    onConfirm(val) {
      this.value = val.label;
      this.frm.c_id = val.value;
      this.showPicker = false;

      this.btypes = [];
      this.idata.forEach((item) => {
        if (item.id == val.value) {
          if (item.networkList && item.networkList.length > 0) {
            this.btypes = item.networkList;
          }
        }
      });

      this.frm.a_id = this.btypes[0].id;
      this.icon = this.btypes[0].pay_img;
      this.address = this.btypes[0].address;
    },
    async getAddress() {
      await this.$http({
        method: "get",
        url: "getrecharge",
      }).then((res) => {
        this.idata = res.data.list;
        this.columns = [];
        let tmpitem = {};
        res.data.list.forEach((item) => {
          if (this.frm.c_id && this.frm.c_id == item.id) {
            tmpitem = { value: item.id, label: item.title };
          }
          this.columns.push({ value: item.id, label: item.title });
        });
        if (!this.frm.c_id) {
          tmpitem = this.columns[0];
        }
        this.onConfirm(tmpitem);
      });
    },
    async File1AferReade(file) {
      file.status = "uploading";
      const formData = new FormData();
      formData.append("file", file.file);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Token: getToken(),
          Lang: getTokenbyName(TokenLangKey),
        },
      };
      await Axios.post("/api/api/common/upload", formData, config)
        .then((response) => {
          file.status = "";
          this.frm.payimg = response.data.data.url;
        })
        .catch((error) => {
          file.status = "failed";
          console.log(error);
        });
    },
    file1Delete() {
      this.frm.payimg = null;
      this.fileList = [];
    },
  },
  mounted() {
    this.getAddress();
  },
};
</script>

<style>
</style>
